<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <div v-if="loading && formType === 'update' && !current" class="text-center py-4">
        <span class="spinner"></span>
      </div>
      <dropdown-form-box v-else :form-type="formType" :initial="formInitial" @create="onCreate" @update="onUpdate" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DropdownFormBox from '../../components/DropdownFormBox.vue';

export default {
  name: 'DropdownForm',
  components: { DropdownFormBox },
  data() {
    return {
      formType: 'new'
    };
  },
  metaInfo() {
    return {
      title: this.title
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'New dropdown' : 'Edit dropdown';
    },
    formInitial() {
      return this.current;
    },
    routeKey() {
      return this.$route.params.key ? decodeURIComponent(this.$route.params.key) : '';
    },
    ...mapState('dropdownAdmin', ['loading', 'current'])
  },
  async mounted() {
    if (this.$route.name === 'dropdown-admin-new') {
      this.formType = 'new';
    } else {
      this.formType = 'update';
      await this.getOne({
        key: this.routeKey,
        router: this.$router
      });
    }
  },
  methods: {
    ...mapActions('dropdownAdmin', ['getOne', 'postOne', 'patchOne']),
    onCreate({ payload }) {
      this.postOne({
        payload,
        router: this.$router,
        redirectUrl: '/dropdowns-admin'
      });
    },
    onUpdate({ payload }) {
      const body = { ...payload };
      delete body.originalKey;
      this.patchOne({
        key: this.routeKey,
        payload: body,
        router: this.$router,
        redirectUrl: '/dropdowns-admin'
      });
    }
  }
};
</script>
